import _default from './Sticky';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Sticky/index.js
// module id = 1565
// module chunks = 1